import { styled } from "@mui/material";
import BgRippon from "../../assets/images/bg_shade.png";

const StyledBanner = styled("section")(({ theme }) => ({
  height: "100vh",
  position: "relative",
  overflow: "hidden",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  "&::before": {
    content: '""',
    width: "80px",
    height: "100%",
    position: "absolute",
    top: "0",
    left: "0",
    backgroundImage: `url(${BgRippon})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 70%",
    "@media screen and (max-width:600px)": {
      backgroundImage: "none",
    },
  },
}));

export default StyledBanner;
